const isInternalLink = (targetURL: string) => {
  if (!targetURL || typeof targetURL !== 'string') return false;
  if (targetURL.startsWith('sso:')) return false;
  if (/^https?:\/\//i.test(targetURL)) return false;
  if (targetURL.startsWith('//')) return false;
  return true;
};

const openNewTab = (resolvedURL: string) => {
  const rootWindow = window.top && window.top !== window ? window.top : window;
  try {
    const newWindow = rootWindow.open(resolvedURL, '_blank');
    if (newWindow) {
      newWindow.opener = null;
      newWindow.focus?.();
    }
  } catch {
    const newWindow = window.open(resolvedURL, '_blank');
    if (newWindow) {
      newWindow.opener = null;
      newWindow.focus?.();
    }
  }
};

export const openInternalLinkAsExternal = (targetURL: string) => {
  if (!process.client) return false;
  const route = useRoute();
  if (!route.path.startsWith('/plugins/')) return false;
  if (!isInternalLink(targetURL)) return false;
  const runtimeConfig = useRuntimeConfig();
  const candidateBaseUrl =
    runtimeConfig.public.redirectBaseURL ||
    window.location.origin ||
    runtimeConfig.public.buyerAppBaseURL ||
    '';
  let baseOrigin = window.location.origin;
  try {
    baseOrigin = new URL(candidateBaseUrl).origin;
  } catch {
    baseOrigin = window.location.origin;
  }
  const resolvedURL = new URL(targetURL, baseOrigin).toString();
  openNewTab(resolvedURL);
  return true;
};
